import * as whintegration from '@webhare-system/wh/integration';
import * as domdebug from 'dompack/src/debug';

module.exports = { config: whintegration.config
                 , debug: domdebug.debugflags
                 };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/system/nodejs/compat/base.es